import { GridSync, IIdentity } from '.';
export interface ChangesConfig<T extends IIdentity> {
  /**
   * @description Don't mark edited cells as changed
   */
  disableHighlighting?: boolean;
  changesAdapter?: (changes: GridSync<T>) => GridSync<T>;
}
